import { styled } from "styled-components";

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.default[300]};
`;

export const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
`;

export const QuestionItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.default[100]}`};
  cursor: pointer;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.colors.default[400]};
  }

  & > a {
    height: 100%;
    width: 100%;
    padding: 20px 0px;
  }
`;
